/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class AccountService {
  /**
   *
   */
  static getLoggedInUserDetails(options: IRequestOptions = {}): Promise<UserDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/me';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static switchCurrentProfile(
    params: {
      /** requestBody */
      body?: SwitchCurrentProfileCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/switch-current-profile';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCurrentProfile(options: IRequestOptions = {}): Promise<Int32NullableApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/get-current-profile';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCookieExpiration(options: IRequestOptions = {}): Promise<DoubleApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/cookie-expiration';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static externalLogin(
    params: {
      /**  */
      provider?: string;
      /**  */
      returnUrl?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/ExternalLogin';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { provider: params['provider'], returnUrl: params['returnUrl'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static externalLoginCallback(
    params: {
      /**  */
      returnUrl?: string;
      /**  */
      remoteError?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/ExternalLoginCallback';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { returnUrl: params['returnUrl'], remoteError: params['remoteError'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static register(
    params: {
      /**  */
      returnUrl?: string;
      /** requestBody */
      body?: RegisterUserCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/register';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { returnUrl: params['returnUrl'] };
      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static login(
    params: {
      /** requestBody */
      body?: PasswordLoginCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StringApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static forgotUsername(
    params: {
      /** requestBody */
      body?: ForgotUsernameCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/forgotusername';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static forgotPassword(
    params: {
      /** requestBody */
      body?: ForgotPasswordCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/forgotpassword';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resetPassword(
    params: {
      /** requestBody */
      body?: ResetPasswordCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/resetpassword';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changePassword(
    params: {
      /** requestBody */
      body?: ChangePasswordCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/changepassword';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changeEmail(
    params: {
      /** requestBody */
      body?: ChangeEmailCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/changeemail';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changeCommunicationPreference(
    params: {
      /** requestBody */
      body?: UpdateCommunicationPreferenceCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/communicationpreference';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static logout(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/logout';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static confirmAccountRedirect(
    params: {
      /**  */
      userName?: string;
      /**  */
      token?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/confirm-account-redirect';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { userName: params['userName'], token: params['token'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static confirmAccount(
    params: {
      /**  */
      userName?: string;
      /**  */
      token?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AccountConfirmationResultApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/account/confirm-account';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { userName: params['userName'], token: params['token'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ActivitiesService {
  /**
   *
   */
  static createActivity(
    params: {
      /** requestBody */
      body?: CreateActivityCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activities/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getActivityById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activities/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteActivity(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activities/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getActivitiesByParticipantId(
    params: {
      /**  */
      participantId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activities/participant/{participantId}';
      url = url.replace('{participantId}', params['participantId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateActivity(
    params: {
      /** requestBody */
      body?: UpdateActivityCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activities/update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ActivityTrackersService {
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityTrackerDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activity-trackers/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTrackerById(
    params: {
      /**  */
      trackerId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityTrackerDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activity-trackers/{trackerId}';
      url = url.replace('{trackerId}', params['trackerId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createActivityTracker(
    params: {
      /** requestBody */
      body?: CreateActivityTrackerCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activity-trackers';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateActivityTracker(
    params: {
      /** requestBody */
      body?: UpdateActivityTrackerCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/activity-trackers';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BodyTraceService {
  /**
   *
   */
  static syncWeight(
    params: {
      /** requestBody */
      body?: SyncWeightCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/bodytrace';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CounselorsService {
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CounselorDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/counselors/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCounselorById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CounselorDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/counselors/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createCounselor(
    params: {
      /** requestBody */
      body?: CreateCounselorCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CounselorDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/counselors';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateCounselor(
    params: {
      /** requestBody */
      body?: UpdateCounselorCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CounselorDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/counselors';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FeatureManagementService {
  /**
   *
   */
  static getEnabledFeatures(options: IRequestOptions = {}): Promise<FeatureEnabledStatusListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/features/enabled-features';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FileResourcesService {
  /**
   *
   */
  static getBySasToken(
    params: {
      /**  */
      fileResourceGuid: string;
      /**  */
      token?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/file-resources/{fileResourceGuid}';
      url = url.replace('{fileResourceGuid}', params['fileResourceGuid'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { token: params['token'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class GoalsService {
  /**
   *
   */
  static createGoal(
    params: {
      /** requestBody */
      body?: CreateGoalCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateGoal(
    params: {
      /** requestBody */
      body?: UpdateGoalCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteGoal(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getGoalById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GoalDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static disableGoal(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals/disable/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getGoalsByParticipantId(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GoalDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals/participant/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getGoalsByParentId(
    params: {
      /**  */
      parentId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParentGoalDtoIEnumerableApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals/parent/{parentId}';
      url = url.replace('{parentId}', params['parentId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAvailableGoalTypes(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StringOptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals/participant/{id}/goal-types';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDefaultStartDate(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DateOnlyNullableApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/goals/participant/{id}/default-start-date';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class GroupsService {
  /**
   *
   */
  static getTable(
    params: {
      /**  */
      siteId?: number;
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GroupDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/groups/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { siteId: params['siteId'] };
      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getGroupById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GroupDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/groups/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteGroupById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/groups/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createGroup(
    params: {
      /** requestBody */
      body?: CreateGroupCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/groups';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateGroup(
    params: {
      /** requestBody */
      body?: UpdateGroupCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/groups';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getGroupOptions(
    params: {
      /**  */
      siteId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/groups/groupOptions/{siteId}';
      url = url.replace('{siteId}', params['siteId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDefaultGroup(options: IRequestOptions = {}): Promise<DefaultGroupDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/groups/defaultGroup';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class MessagesService {
  /**
   *
   */
  static getMessageThreads(options: IRequestOptions = {}): Promise<MessageThreadDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/messages';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createMessage(
    params: {
      /** requestBody */
      body?: CreateMessageCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/messages';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMessageThread(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MessageGroupDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/messages/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRecipientOptions(options: IRequestOptions = {}): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/messages/recipient-options';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUnreadCount(options: IRequestOptions = {}): Promise<Int32ApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/messages/unread-count';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class MobileConfigurationService {
  /**
   *
   */
  static checkForForcedUpdate(
    params: {
      /**  */
      version: string;
      /**  */
      platform: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/mobile-configuration/{version}/{platform}';
      url = url.replace('{version}', params['version'] + '');
      url = url.replace('{platform}', params['platform'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ParticipantsService {
  /**
   *
   */
  static getParticipantsByStudyAndArm(
    params: {
      /**  */
      siteId?: number;
      /**  */
      groupId?: number;
      /**  */
      studyId?: number;
      /**  */
      studyArmId?: number;
      /**  */
      counselorId?: number;
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParticipantDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/participants-by-study-and-arm';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = {
        siteId: params['siteId'],
        groupId: params['groupId'],
        studyId: params['studyId'],
        studyArmId: params['studyArmId'],
        counselorId: params['counselorId']
      };
      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getParticipantsByCounselor(
    params: {
      /**  */
      counselorId?: number;
      /** requestBody */
      body?: UnlimitedTakeDataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParticipantListItemDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/participants-by-counselor';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { counselorId: params['counselorId'] };
      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: GetLegacyParticipantsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LegacyParticipantDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLegacyParticipantAndWeightsById(
    params: {
      /**  */
      id: number;
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LegacyParticipantDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/legacy/data/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { StartDate: params['startDate'], EndDate: params['endDate'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getParticipantAndWeightsById(
    params: {
      /**  */
      id: number;
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParticipantDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/data/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { StartDate: params['startDate'], EndDate: params['endDate'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getParticipantById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParticipantDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteParticipantById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createParticipant(
    params: {
      /** requestBody */
      body?: CreateParticipantCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateParticipant(
    params: {
      /** requestBody */
      body?: UpdateParticipantCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createLegacyParticipant(
    params: {
      /** requestBody */
      body?: CreateLegacyParticipantCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/legacy';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateLegacyParticipant(
    params: {
      /** requestBody */
      body?: UpdateLegacyParticipantCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/legacy';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCounselorOptions(
    params: {
      /**  */
      counselorId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/counselorOptions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { counselorId: params['counselorId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCounselorOptionsByGroup(
    params: {
      /**  */
      groupId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/counselorOptionsByGroup';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { groupId: params['groupId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLegacyParticipantOptions(
    params: {
      /**  */
      participantId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/legacyParticipantOptions/{participantId}';
      url = url.replace('{participantId}', params['participantId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getParticipantOptions(
    params: {
      /**  */
      participantId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/participantOptions/{participantId}';
      url = url.replace('{participantId}', params['participantId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getScaleOptions(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/scaleOptions/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getActivityTrackerOptions(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/activityTrackerOptions/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPercentOptions(options: IRequestOptions = {}): Promise<StringOptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/percentOptions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getParentOptions(options: IRequestOptions = {}): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/parentOptions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getParticipantRelationshipsById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParentRelationshipDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/relationships/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static backfillWeightGraphCache(
    options: IRequestOptions = {}
  ): Promise<BackfillCachedWeightGraphDataResultApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/backfill-weight-graph-cache';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSessionAttendanceByParticipantId(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SessionAttendanceDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/session-attendance/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getParticipantToolboxBySite(
    params: {
      /**  */
      counselorId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParticipantStudyToolboxDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/participants/toolbox';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { counselorId: params['counselorId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PediatricsService {
  /**
   *
   */
  static status(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/pediatrics/Status';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ScalesService {
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ScaleDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/scales/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getScaleById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ScaleDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/scales/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteScaleById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/scales/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createScale(
    params: {
      /** requestBody */
      body?: CreateScaleCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/scales';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateScale(
    params: {
      /** requestBody */
      body?: UpdateScaleCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/scales';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static importScales(
    params: {
      /**  */
      imageFile: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/scales/import';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['imageFile']) {
        if (Object.prototype.toString.call(params['imageFile']) === '[object Array]') {
          for (const item of params['imageFile']) {
            data.append('ImageFile', item as any);
          }
        } else {
          data.append('ImageFile', params['imageFile'] as any);
        }
      }

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SessionMaterialBankService {
  /**
   *
   */
  static getAll(options: IRequestOptions = {}): Promise<SessionMaterialBankEntryListItemDtoArrayApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-material-bank';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /**  */
      studyIds: [];
      /**  */
      files: [];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-material-bank/create';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['studyIds']) {
        if (Object.prototype.toString.call(params['studyIds']) === '[object Array]') {
          for (const item of params['studyIds']) {
            data.append('StudyIds', item as any);
          }
        } else {
          data.append('StudyIds', params['studyIds'] as any);
        }
      }

      if (params['files']) {
        if (Object.prototype.toString.call(params['files']) === '[object Array]') {
          for (const item of params['files']) {
            data.append('Files', item as any);
          }
        } else {
          data.append('Files', params['files'] as any);
        }
      }

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static archive(
    params: {
      /** requestBody */
      body?: ArchiveSessionMaterialBankEntryCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-material-bank/archive';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateStudies(
    params: {
      /** requestBody */
      body?: UpdateSessionMaterialBankEntryStudiesCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-material-bank/update-studies';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getFile(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FileResourceUriResultApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-material-bank/file/{id}';
      url = url.replace('{Id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SessionMaterialsService {
  /**
   *
   */
  static getMaterials(
    params: {
      /**  */
      sessionId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SessionMaterialDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { sessionId: params['sessionId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static addMaterials(
    params: {
      /**  */
      sessionId: number;
      /**  */
      file: any;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = null;
      data = new FormData();
      if (params['sessionId']) {
        if (Object.prototype.toString.call(params['sessionId']) === '[object Array]') {
          for (const item of params['sessionId']) {
            data.append('SessionId', item as any);
          }
        } else {
          data.append('SessionId', params['sessionId'] as any);
        }
      }

      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('File', item as any);
          }
        } else {
          data.append('File', params['file'] as any);
        }
      }

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteMaterials(
    params: {
      /** requestBody */
      body?: DeleteSessionMaterialCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials/delete';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateFileName(
    params: {
      /** requestBody */
      body?: UpdateMaterialFileNameCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials/file-name';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMaterialOptionsBySession(
    params: {
      /**  */
      sessionId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials/material-options';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { sessionId: params['sessionId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBankMaterialOptionsByStudy(
    params: {
      /**  */
      studyId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials/bank-material-options';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { studyId: params['studyId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateBankMaterial(
    params: {
      /** requestBody */
      body?: UpdateSessionBankMaterialCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials/bank-material';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBankList(options: IRequestOptions = {}): Promise<SessionMaterialBankEntryListItemDtoArrayApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials/bank-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBankFile(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-materials/bank-file/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SessionsService {
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: GetSessionsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SessionListItemDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sessions/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSessionById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SessionListItemDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sessions/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteSession(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sessions/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMetricsByCounselor(
    params: {
      /**  */
      counselorId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SessionMetricsDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sessions/metrics/counselor/{counselorId}';
      url = url.replace('{counselorId}', params['counselorId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createSession(
    params: {
      /** requestBody */
      body?: CreateSessionCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sessions';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateSession(
    params: {
      /** requestBody */
      body?: UpdateSessionCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sessions';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateSessionDetails(
    params: {
      /** requestBody */
      body?: UpdateSessionDetailsCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sessions/details';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SessionSchedulesService {
  /**
   *
   */
  static getSessionScheduleByParticipantId(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SessionScheduleDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-schedules/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createOrUpdateSessionSchedule(
    params: {
      /** requestBody */
      body?: CreateOrUpdateSessionScheduleCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/session-schedules';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SettingsService {
  /**
   *
   */
  static getSettingByKey(
    params: {
      /**  */
      key: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SettingDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/settings/{key}';
      url = url.replace('{key}', params['key'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SettingDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/settings/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SettingDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/settings/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static edit(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: SettingDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/settings/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/settings/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: SettingDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/settings';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SitesService {
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SiteDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sites/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSiteById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SiteDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sites/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteSiteById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sites/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createSite(
    params: {
      /** requestBody */
      body?: CreateSiteCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sites';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateSite(
    params: {
      /** requestBody */
      body?: UpdateSiteCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sites';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getManagerOptions(options: IRequestOptions = {}): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sites/managerOptions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSiteOptions(options: IRequestOptions = {}): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sites/siteOptions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDefaultSite(options: IRequestOptions = {}): Promise<Int32ApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sites/defaultSite';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class StatusService {
  /**
   *
   */
  static getStatusAsync(options: IRequestOptions = {}): Promise<StatusResultListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/status';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class StickerChartService {
  /**
   *
   */
  static getStickerChart(
    params: {
      /** requestBody */
      body?: GetStickerChartQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StickerChartDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sticker-charts/get-progress';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static submitStickerChartAction(
    params: {
      /** requestBody */
      body?: SubmitStickerChartActionCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/sticker-charts/submit-action';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class StudiesService {
  /**
   *
   */
  static getTable(
    params: {
      /**  */
      siteId?: number;
      /**  */
      groupId?: number;
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StudyListItemDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/studies/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { siteId: params['siteId'], groupId: params['groupId'] };
      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStudyById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StudyDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/studies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteStudyById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/studies/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllStudyOptions(options: IRequestOptions = {}): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/studies/studyOptions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStudyOptions(
    params: {
      /**  */
      groupId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/studies/studyOptions/{groupId}';
      url = url.replace('{groupId}', params['groupId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDefaultStudy(options: IRequestOptions = {}): Promise<DefaultStudyDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/studies/defaultStudy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class StudyArmsService {
  /**
   *
   */
  static getStudyArmsByStudyId(
    params: {
      /**  */
      siteId?: number;
      /**  */
      groupId?: number;
      /**  */
      studyId?: number;
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StudyArmListItemDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms/study-arms-by-study-id';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { siteId: params['siteId'], groupId: params['groupId'], studyId: params['studyId'] };
      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StudyArmListItemDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStudyArmById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StudyArmDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteStudyArmById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createStudyArm(
    params: {
      /** requestBody */
      body?: CreateStudyArmCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateStudyArm(
    params: {
      /** requestBody */
      body?: UpdateStudyArmCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPercentOptions(options: IRequestOptions = {}): Promise<StringOptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms/percentOptions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStudyArmOptions(
    params: {
      /**  */
      studyId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms/studyArmOptions/{studyId}';
      url = url.replace('{studyId}', params['studyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCounselorOptions(
    params: {
      /**  */
      studyArmId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms/counselorOptions/{studyArmId}';
      url = url.replace('{studyArmId}', params['studyArmId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDefaultStudyArm(options: IRequestOptions = {}): Promise<DefaultStudyArmDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/study-arms/defaultStudyArm';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ToolBoxService {
  /**
   *
   */
  static status(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/toolbox/status';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getToolBoxTypes(
    params: {
      /**  */
      participantId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ToolBoxTypeDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/toolbox/toolbox-types/{participantId}';
      url = url.replace('{participantId}', params['participantId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStrategiesByType(
    params: {
      /** requestBody */
      body?: GetToolboxStrategiesByTypeQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ToolBoxStrategyDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/toolbox/strategy-types';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createParticipantStrategy(
    params: {
      /** requestBody */
      body?: CreateParticipantStrategyCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/toolbox/participant-strategy';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllActiveParticipantStrategies(
    params: {
      /** requestBody */
      body?: GetAllActiveParticipantStrategies;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ParticipantStrategyDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/toolbox/all-active-participant-strategies';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static modifyParticipantStrategy(
    params: {
      /** requestBody */
      body?: ModifyParticipantStrategyCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/toolbox/modify-participant-strategy';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getStudyToolBoxTypes(
    params: {
      /** requestBody */
      body?: GetStudyToolboxTypesQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ToolBoxTypeDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/toolbox/study-toolbox-types';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TrophiesService {
  /**
   *
   */
  static getTrophyCase(
    params: {
      /** requestBody */
      body?: GetTrophyCaseQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TrophyCaseDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/trophies/get-trophy-case';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UsersService {
  /**
   *
   */
  static getUsers(
    params: {
      /** requestBody */
      body?: DataTableRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserListItemDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/users/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUser(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/users/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postUserNoPhoto(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: UpdateUserCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/users/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static postUser(
    params: {
      /** requestBody */
      body?: CreateUserCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/users';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static lockUser(
    params: {
      /** requestBody */
      body?: LockUserCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/users/lock';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static unlockUser(
    params: {
      /** requestBody */
      body?: UnlockUserCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/users/unlock';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoleOptions(options: IRequestOptions = {}): Promise<OptionItemDtoListApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/users/roleOptions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendConfirmEmail(
    params: {
      /** requestBody */
      body?: SendConfirmAccountEmailCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/users/sendConfirmEmail';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class WeightsService {
  /**
   *
   */
  static getTable(
    params: {
      /** requestBody */
      body?: GetWeightsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WeightDtoDataTablePageApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/weights/table';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getWeightById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WeightDtoApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/weights/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteWeightById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/weights/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLatestHeightByParticipantId(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Int32ApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/latestByParticipantId/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createWeight(
    params: {
      /** requestBody */
      body?: CreateWeightCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/weights';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateWeight(
    params: {
      /** requestBody */
      body?: UpdateWeightCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/weights';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static syncWeights(
    params: {
      /** requestBody */
      body?: SyncWeightsCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/weights/sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateWeightGraphPhase(
    params: {
      /** requestBody */
      body?: UpdateWeightGraphPhaseCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BooleanApiResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/weights/update-weight-graph-phase';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export interface AccountConfirmationResult {
  /**  */
  isPasswordResetRequired?: boolean;

  /**  */
  code?: string;
}

export interface AccountConfirmationResultApiResult {
  /**  */
  result?: AccountConfirmationResult;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ActivityDto {
  /**  */
  id?: number;

  /**  */
  participantId?: number;

  /**  */
  activityType?: ActivityType;

  /**  */
  hasRecordedSteps?: boolean;

  /**  */
  stepCount?: number;

  /**  */
  hasPerformedBreathingIncreasingActivity?: boolean;

  /**  */
  breathingIncreasingActivityDescription?: string;

  /**  */
  breathingIncreasingActivityMinutes?: number;

  /**  */
  hasInformationBeenReportedFromADevice?: boolean;

  /**  */
  hasPerformedResistanceActivity?: boolean;

  /**  */
  resistanceActivityMinutes?: number;

  /**  */
  activityDate?: Date;

  /**  */
  createdByUserId?: number;

  /**  */
  createdDate?: string;
}

export interface ActivityDtoApiResult {
  /**  */
  result?: ActivityDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ActivityDtoListApiResult {
  /**  */
  result?: ActivityDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ActivityTrackerDto {
  /**  */
  id?: number;

  /**  */
  deviceName?: string;

  /**  */
  createdDateUtc?: string;

  /**  */
  lastUpdatedDateUtc?: string;

  /**  */
  penningtonId?: string;
}

export interface ActivityTrackerDtoApiResult {
  /**  */
  result?: ActivityTrackerDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ActivityTrackerDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: ActivityTrackerDto[];
}

export interface ActivityTrackerDtoDataTablePageApiResult {
  /**  */
  result?: ActivityTrackerDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface AnnotationPointDto {
  /**  */
  x?: number;

  /**  */
  y?: number;

  /**  */
  marker?: Marker;
}

export interface ArchiveSessionMaterialBankEntryCommand {
  /**  */
  id?: number;

  /**  */
  isArchived?: boolean;
}

export interface AuthenticationProperties {
  /**  */
  items?: object;

  /**  */
  parameters?: object;

  /**  */
  isPersistent?: boolean;

  /**  */
  redirectUri?: string;

  /**  */
  issuedUtc?: string;

  /**  */
  expiresUtc?: string;

  /**  */
  allowRefresh?: boolean;
}

export interface BackfillCachedWeightGraphDataResult {
  /**  */
  successfullyBackfilled?: number;

  /**  */
  failed?: number;
}

export interface BackfillCachedWeightGraphDataResultApiResult {
  /**  */
  result?: BackfillCachedWeightGraphDataResult;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface BooleanApiResult {
  /**  */
  result?: boolean;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ChallengeResult {
  /**  */
  authenticationSchemes?: string[];

  /**  */
  properties?: AuthenticationProperties;
}

export interface ChangeEmailCommand {
  /**  */
  userName?: string;

  /**  */
  oldEmail?: string;

  /**  */
  newEmail?: string;

  /**  */
  currentPassword?: string;
}

export interface ChangePasswordCommand {
  /**  */
  password?: string;

  /**  */
  newPassword?: string;

  /**  */
  confirmNewPassword?: string;
}

export interface ChildParticipantDto {
  /**  */
  childId?: number;

  /**  */
  childNickname?: string;
}

export interface CounselorDto {
  /**  */
  id?: number;

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;

  /**  */
  email?: string;

  /**  */
  name?: string;

  /**  */
  siteName?: string;

  /**  */
  groupName?: string;

  /**  */
  hasLegacyAccess?: boolean;
}

export interface CounselorDtoApiResult {
  /**  */
  result?: CounselorDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface CounselorDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: CounselorDto[];
}

export interface CounselorDtoDataTablePageApiResult {
  /**  */
  result?: CounselorDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface CreateActivityCommand {
  /**  */
  participantId?: number;

  /**  */
  activityType?: ActivityType;

  /**  */
  hasRecordedSteps?: boolean;

  /**  */
  stepCount?: number;

  /**  */
  hasPerformedBreathingIncreasingActivity?: boolean;

  /**  */
  breathingIncreasingActivityDescription?: string;

  /**  */
  breathingIncreasingActivityMinutes?: number;

  /**  */
  hasInformationBeenReportedFromADevice?: boolean;

  /**  */
  hasPerformedResistanceActivity?: boolean;

  /**  */
  resistanceActivityMinutes?: number;

  /**  */
  activityDate?: Date;
}

export interface CreateActivityTrackerCommand {
  /**  */
  deviceName?: string;
}

export interface CreateCounselorCommand {
  /**  */
  email?: string;

  /**  */
  name?: string;

  /**  */
  groupId?: number;

  /**  */
  hasLegacyAccess?: boolean;
}

export interface CreateGoalCommand {
  /**  */
  goalSchedule?: GoalScheduleDto;

  /**  */
  goalType?: GoalType;

  /**  */
  responsibleParty?: ResponsibleParty;

  /**  */
  isInStickerChart?: boolean;

  /**  */
  participantId?: number;

  /**  */
  isDisabled?: boolean;
}

export interface CreateGroupCommand {
  /**  */
  name?: string;

  /**  */
  siteId?: number;
}

export interface CreateLegacyParticipantCommand {
  /**  */
  penningtonId?: string;

  /**  */
  email?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  status?: string;

  /**  */
  studyStartDate?: Date;

  /**  */
  studyEndDate?: Date;

  /**  */
  studyIntervalDays?: number;

  /**  */
  age?: number;

  /**  */
  gender?: string;

  /**  */
  height?: number;

  /**  */
  baselineWeight?: number;

  /**  */
  upperBoundBuffer?: number;

  /**  */
  lowerBoundBuffer?: number;

  /**  */
  boundModificationAmount?: number;

  /**  */
  boundModificationWeekInterval?: number;

  /**  */
  percentType?: PercentType;

  /**  */
  percentParameter?: number;

  /**  */
  counselorId?: number;

  /**  */
  scaleId?: number;
}

export interface CreateMessageCommand {
  /**  */
  body?: string;

  /**  */
  recipientId?: number;
}

export interface CreateOrUpdateSessionScheduleCommand {
  /**  */
  startDate?: string;

  /**  */
  frequency?: SessionFrequency;

  /**  */
  participantId?: number;
}

export interface CreateParticipantCommand {
  /**  */
  penningtonId?: string;

  /**  */
  isChild?: boolean;

  /**  */
  nickname?: string;

  /**  */
  userName?: string;

  /**  */
  email?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  communicationPreference?: CommunicationPreference;

  /**  */
  status?: string;

  /**  */
  studyStartDate?: Date;

  /**  */
  studyEndDate?: Date;

  /**  */
  firstScheduledSessionDate?: string;

  /**  */
  dateOfBirth?: string;

  /**  */
  age?: number;

  /**  */
  gender?: string;

  /**  */
  height?: number;

  /**  */
  baselineWeight?: number;

  /**  */
  counselorId?: number;

  /**  */
  scaleId?: number;

  /**  */
  activityTrackerId?: number;

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;

  /**  */
  studyId?: number;

  /**  */
  studyArmId?: number;

  /**  */
  parentParticipantIds?: number[];

  /**  */
  canCheckOffStickerChartAsChild?: boolean;

  /**  */
  canViewBmiPercentile?: boolean;

  /**  */
  canViewWeightGraph?: boolean;

  /**  */
  canTrackActivity?: boolean;
}

export interface CreateParticipantStrategyCommand {
  /**  */
  studyArmId?: number;

  /**  */
  toolBoxStrategyId?: number;

  /**  */
  value?: string;

  /**  */
  participantId?: number;
}

export interface CreateScaleCommand {
  /**  */
  name?: string;

  /**  */
  scaleImei?: string;
}

export interface CreateSessionCommand {
  /**  */
  scheduledDate?: string;

  /**  */
  participantId?: number;
}

export interface CreateSiteCommand {
  /**  */
  name?: string;

  /**  */
  managerIds?: number[];
}

export interface CreateStudyArmCommand {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  weightLossApproach?: PercentType;

  /**  */
  percentParameter?: number;

  /**  */
  upperBoundBuffer?: number;

  /**  */
  maxUpperBound?: number;

  /**  */
  lowerBoundBuffer?: number;

  /**  */
  maxLowerBound?: number;

  /**  */
  boundModificationAmount?: number;

  /**  */
  boundModificationWeekInterval?: number;

  /**  */
  weightLossPeriod?: number;

  /**  */
  weightMaintenancePeriod?: number;

  /**  */
  studyId?: number;
}

export interface CreateUserCommand {
  /**  */
  email?: string;

  /**  */
  name?: string;

  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  confirmPassword?: string;

  /**  */
  status?: number;

  /**  */
  userRole?: number;

  /**  */
  hasLegacyAccess?: boolean;
}

export interface CreateWeightCommand {
  /**  */
  kilograms?: number;

  /**  */
  pounds?: number;

  /**  */
  createdDate?: string;

  /**  */
  participantId?: number;

  /**  */
  height?: number;

  /**  */
  useLbs?: boolean;

  /**  */
  isExcluded?: boolean;
}

export interface CreatedEntity {
  /**  */
  type?: string;

  /**  */
  id?: number;
}

export interface DataPointDto {
  /**  */
  x?: Date;

  /**  */
  y?: number;
}

export interface DataTableColumn {
  /**  */
  propertyName?: string;

  /**  */
  sortDirection?: string;

  /**  */
  searchTerm?: string;
}

export interface DataTableRequest {
  /**  */
  tableEcho?: number;

  /**  */
  skip?: number;

  /**  */
  take?: number;

  /**  */
  allSearch?: string;

  /**  */
  columns?: DataTableColumn[];

  /**  */
  includeColumns?: boolean;
}

export interface DateOnlyNullableApiResult {
  /**  */
  result?: Date;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface DefaultGroupDto {
  /**  */
  siteId?: number;

  /**  */
  groupId?: number;
}

export interface DefaultGroupDtoApiResult {
  /**  */
  result?: DefaultGroupDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface DefaultStudyArmDto {
  /**  */
  studyArmId?: number;

  /**  */
  studyId?: number;

  /**  */
  allowChildLogin?: boolean;

  /**  */
  enabledToolBoxes?: EnabledToolBoxDto[];

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;
}

export interface DefaultStudyArmDtoApiResult {
  /**  */
  result?: DefaultStudyArmDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface DefaultStudyDto {
  /**  */
  studyId?: number;

  /**  */
  allowChildLogin?: boolean;

  /**  */
  enabledToolBoxes?: EnabledToolBoxDto[];

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;
}

export interface DefaultStudyDtoApiResult {
  /**  */
  result?: DefaultStudyDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface DeleteSessionMaterialCommand {
  /**  */
  fileIds?: number[];
}

export interface DoubleApiResult {
  /**  */
  result?: number;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface EnabledToolBoxDto {
  /**  */
  toolBoxType?: ToolBoxType;

  /**  */
  isEnabled?: boolean;
}

export interface FeatureEnabledStatus {
  /**  */
  featureFlagType?: FeatureFlagType;

  /**  */
  isEnabled?: boolean;
}

export interface FeatureEnabledStatusListApiResult {
  /**  */
  result?: FeatureEnabledStatus[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface FileResourceUriResult {
  /**  */
  uri?: string;

  /**  */
  cacheUntil?: string;

  /**  */
  guid?: string;

  /**  */
  fileName?: string;

  /**  */
  mimeType?: string;
}

export interface FileResourceUriResultApiResult {
  /**  */
  result?: FileResourceUriResult;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ForgotPasswordCommand {
  /**  */
  email?: string;

  /**  */
  userName?: string;
}

export interface ForgotUsernameCommand {
  /**  */
  email?: string;
}

export interface GetAllActiveParticipantStrategies {
  /**  */
  studyArmId?: number;

  /**  */
  toolBoxType?: ToolBoxType;

  /**  */
  participantId?: number;
}

export interface GetLegacyParticipantsRequest {
  /**  */
  tableEcho?: number;

  /**  */
  skip?: number;

  /**  */
  take?: number;

  /**  */
  allSearch?: string;

  /**  */
  columns?: DataTableColumn[];

  /**  */
  includeColumns?: boolean;
}

export interface GetSessionsRequest {
  /**  */
  participantId?: number;

  /**  */
  tableEcho?: number;

  /**  */
  skip?: number;

  /**  */
  take?: number;

  /**  */
  allSearch?: string;

  /**  */
  columns?: DataTableColumn[];

  /**  */
  includeColumns?: boolean;
}

export interface GetStickerChartQuery {
  /**  */
  debugStartDate?: string;

  /**  */
  participantId?: number;
}

export interface GetStudyToolboxTypesQuery {
  /**  */
  studyId?: number;

  /**  */
  participantId?: number;
}

export interface GetToolboxStrategiesByTypeQuery {
  /**  */
  toolBoxType?: ToolBoxType;

  /**  */
  participantId?: number;
}

export interface GetTrophyCaseQuery {
  /**  */
  participantId?: number;
}

export interface GetWeightsRequest {
  /**  */
  participantId?: number;

  /**  */
  tableEcho?: number;

  /**  */
  skip?: number;

  /**  */
  take?: number;

  /**  */
  allSearch?: string;

  /**  */
  columns?: DataTableColumn[];

  /**  */
  includeColumns?: boolean;
}

export interface GoalDto {
  /**  */
  id?: number;

  /**  */
  goalType?: GoalType;

  /**  */
  responsibleParty?: ResponsibleParty;

  /**  */
  isInStickerChart?: boolean;

  /**  */
  isDisabled?: boolean;

  /**  */
  participantId?: number;

  /**  */
  currentGoalSchedule?: GoalScheduleDto;

  /**  */
  futureGoalSchedule?: GoalScheduleDto;

  /**  */
  goalMetStatus?: GoalMetStatus;
}

export interface GoalDtoApiResult {
  /**  */
  result?: GoalDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface GoalDtoListApiResult {
  /**  */
  result?: GoalDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface GoalScheduleDto {
  /**  */
  effectiveDate?: Date;

  /**  */
  action?: string;

  /**  */
  frequency?: number;
}

export interface GoalScheduleDtoWithoutDate {
  /**  */
  action?: string;

  /**  */
  frequency?: number;
}

export interface GraphDto {
  /**  */
  series?: SeriesDto[];

  /**  */
  annotationPoints?: AnnotationPointDto[];

  /**  */
  indicator?: WeightGraphIndicator;

  /**  */
  bmiPercentile?: number;

  /**  */
  availablePhaseTypeTransition?: WeightGraphPhaseType;

  /**  */
  initialZoomTo?: Date;
}

export interface GroupDto {
  /**  */
  id?: number;

  /**  */
  siteId?: number;

  /**  */
  name?: string;

  /**  */
  siteName?: string;
}

export interface GroupDtoApiResult {
  /**  */
  result?: GroupDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface GroupDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: GroupDto[];
}

export interface GroupDtoDataTablePageApiResult {
  /**  */
  result?: GroupDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface Int32ApiResult {
  /**  */
  result?: number;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface Int32NullableApiResult {
  /**  */
  result?: number;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface LegacyParticipantDto {
  /**  */
  id?: number;

  /**  */
  penningtonId?: string;

  /**  */
  email?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  status?: string;

  /**  */
  studyStartDate?: Date;

  /**  */
  studyEndDate?: Date;

  /**  */
  studyIntervalDays?: number;

  /**  */
  age?: number;

  /**  */
  gender?: string;

  /**  */
  height?: number;

  /**  */
  baselineWeight?: number;

  /**  */
  goalWeight?: number;

  /**  */
  baselineEnergyIntake?: number;

  /**  */
  newEnergyIntake?: number;

  /**  */
  upperBoundBuffer?: number;

  /**  */
  lowerBoundBuffer?: number;

  /**  */
  boundModificationAmount?: number;

  /**  */
  boundModificationWeekInterval?: number;

  /**  */
  percentType?: PercentType;

  /**  */
  percentParameter?: number;

  /**  */
  counselorEmail?: string;

  /**  */
  scaleName?: string;

  /**  */
  indicator?: WeightGraphIndicator;

  /**  */
  latestWeight?: number;

  /**  */
  latestWeighIn?: string;

  /**  */
  counselorId?: number;

  /**  */
  scaleId?: number;

  /**  */
  graphData?: GraphDto;
}

export interface LegacyParticipantDtoApiResult {
  /**  */
  result?: LegacyParticipantDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface LegacyParticipantDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: LegacyParticipantDto[];
}

export interface LegacyParticipantDtoDataTablePageApiResult {
  /**  */
  result?: LegacyParticipantDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface LockUserCommand {
  /**  */
  userName?: string;
}

export interface Marker {
  /**  */
  fillColor?: string;

  /**  */
  strokeColor?: string;

  /**  */
  size?: number;

  /**  */
  shape?: string;
}

export interface MessageDto {
  /**  */
  body?: string;

  /**  */
  sentByParticipant?: boolean;

  /**  */
  timestamp?: string;
}

export interface MessageGroupDto {
  /**  */
  messages?: MessageDto[];

  /**  */
  contactName?: string;

  /**  */
  contactEmail?: string;

  /**  */
  contactPhone?: string;

  /**  */
  contactId?: string;

  /**  */
  latestMessageReplyableStatus?: MessageReplyableStatus;

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;

  /**  */
  studyId?: number;

  /**  */
  studyArmId?: number;
}

export interface MessageGroupDtoApiResult {
  /**  */
  result?: MessageGroupDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface MessageThreadDto {
  /**  */
  id?: number;

  /**  */
  contactName?: string;

  /**  */
  latestMessageBody?: string;

  /**  */
  unreadCount?: number;

  /**  */
  sentByParticipant?: boolean;

  /**  */
  participantId?: number;

  /**  */
  nonParticipantId?: number;

  /**  */
  lastMessageDate?: string;
}

export interface MessageThreadDtoListApiResult {
  /**  */
  result?: MessageThreadDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ModifyParticipantStrategyCommand {
  /**  */
  studyArmId?: number;

  /**  */
  participantStrategyId?: number;

  /**  */
  participantId?: number;

  /**  */
  action?: ParticipantStrategyAction;

  /**  */
  value?: string;
}

export interface OptionItemDto {
  /**  */
  value?: number;

  /**  */
  label?: string;

  /**  */
  metadata?: any | null;
}

export interface OptionItemDtoListApiResult {
  /**  */
  result?: OptionItemDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ParentGoalDto {
  /**  */
  participantId?: number;

  /**  */
  penningtonId?: string;

  /**  */
  nickname?: string;

  /**  */
  goals?: GoalDto[];
}

export interface ParentGoalDtoIEnumerableApiResult {
  /**  */
  result?: ParentGoalDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ParentRelationshipDto {
  /**  */
  parents?: ParticipantRelationDto[];

  /**  */
  children?: ParticipantRelationDto[];
}

export interface ParentRelationshipDtoApiResult {
  /**  */
  result?: ParentRelationshipDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ParticipantDto {
  /**  */
  id?: number;

  /**  */
  penningtonId?: string;

  /**  */
  nickname?: string;

  /**  */
  userName?: string;

  /**  */
  email?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  communicationPreference?: CommunicationPreference;

  /**  */
  status?: string;

  /**  */
  studyStartDate?: Date;

  /**  */
  studyEndDate?: Date;

  /**  */
  studyIntervalDays?: number;

  /**  */
  dateOfBirth?: string;

  /**  */
  age?: number;

  /**  */
  gender?: string;

  /**  */
  height?: number;

  /**  */
  baselineWeight?: number;

  /**  */
  goalWeight?: number;

  /**  */
  baselineEnergyIntake?: number;

  /**  */
  newEnergyIntake?: number;

  /**  */
  counselorEmail?: string;

  /**  */
  scaleName?: string;

  /**  */
  indicator?: WeightGraphIndicator;

  /**  */
  latestWeight?: number;

  /**  */
  latestWeighIn?: string;

  /**  */
  lastCompletedSession?: string;

  /**  */
  completedSessionCount?: number;

  /**  */
  counselorId?: number;

  /**  */
  scaleId?: number;

  /**  */
  activityTrackerId?: number;

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;

  /**  */
  studyId?: number;

  /**  */
  studyArmId?: number;

  /**  */
  isChild?: boolean;

  /**  */
  canCheckOffStickerChartAsChild?: boolean;

  /**  */
  canViewBmiPercentile?: boolean;

  /**  */
  canViewWeightGraph?: boolean;

  /**  */
  canTrackActivity?: boolean;

  /**  */
  graphData?: GraphDto;

  /**  */
  parentParticipantIds?: number[];

  /**  */
  bmiPercentile?: number;

  /**  */
  latestMessageCounselorId?: number;

  /**  */
  participantUserId?: number;

  /**  */
  firstScheduledSessionDate?: string;

  /**  */
  useLegacySessionSchedule?: boolean;
}

export interface ParticipantDtoApiResult {
  /**  */
  result?: ParticipantDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ParticipantDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: ParticipantDto[];
}

export interface ParticipantDtoDataTablePageApiResult {
  /**  */
  result?: ParticipantDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ParticipantListItemDto {
  /**  */
  id?: number;

  /**  */
  penningtonId?: string;

  /**  */
  nickname?: string;

  /**  */
  counselorEmail?: string;

  /**  */
  status?: string;

  /**  */
  studyName?: string;

  /**  */
  studyStartDate?: Date;

  /**  */
  studyEndDate?: Date;

  /**  */
  weightGraphIndicator?: string;

  /**  */
  latestWeight?: number;

  /**  */
  latestWeighIn?: string;

  /**  */
  siteName?: string;

  /**  */
  groupName?: string;

  /**  */
  isChild?: boolean;

  /**  */
  counselorId?: number;

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;

  /**  */
  studyId?: number;

  /**  */
  studyArmId?: number;

  /**  */
  age?: number;

  /**  */
  latestMessageCounselorId?: number;

  /**  */
  participantUserId?: number;

  /**  */
  canTrackActivity?: boolean;
}

export interface ParticipantListItemDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: ParticipantListItemDto[];
}

export interface ParticipantListItemDtoDataTablePageApiResult {
  /**  */
  result?: ParticipantListItemDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ParticipantRelationDto {
  /**  */
  id?: number;

  /**  */
  penningtonId?: string;

  /**  */
  nickname?: string;
}

export interface ParticipantStrategyDto {
  /**  */
  id?: number;

  /**  */
  strategyType?: StrategyType;

  /**  */
  strategyText?: string;

  /**  */
  initiatedDate?: string;

  /**  */
  value?: string;

  /**  */
  isCounselorLed?: boolean;

  /**  */
  participantStrategyStatus?: ParticipantStrategyStatus;

  /**  */
  hasActivityLink?: boolean;

  /**  */
  toolBoxType?: ToolBoxType;
}

export interface ParticipantStrategyDtoListApiResult {
  /**  */
  result?: ParticipantStrategyDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ParticipantStudyToolboxDto {
  /**  */
  id?: number;

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;

  /**  */
  studyId?: number;

  /**  */
  studyArmId?: number;

  /**  */
  penningtonId?: string;

  /**  */
  nickname?: string;

  /**  */
  study?: string;

  /**  */
  isAttendanceToolboxInitiated?: boolean;

  /**  */
  isPhysicalActivityToolboxInitiated?: boolean;

  /**  */
  isWeightTrackingToolboxInitiated?: boolean;

  /**  */
  isDietaryAdherenceToolboxInitiated?: boolean;

  /**  */
  isSelfMonitoringToolboxInitiated?: boolean;

  /**  */
  isSubjectiveWellBeingAndQualityToolboxInitiated?: boolean;
}

export interface ParticipantStudyToolboxDtoListApiResult {
  /**  */
  result?: ParticipantStudyToolboxDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface PasswordLoginCommand {
  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  rememberMe?: boolean;
}

export interface RegisterUserCommand {
  /**  */
  email?: string;

  /**  */
  password?: string;

  /**  */
  confirmPassword?: string;
}

export interface ResetPasswordCommand {
  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  confirmPassword?: string;

  /**  */
  code?: string;
}

export interface ScaleDto {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  scaleImei?: string;

  /**  */
  participant?: string;
}

export interface ScaleDtoApiResult {
  /**  */
  result?: ScaleDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ScaleDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: ScaleDto[];
}

export interface ScaleDtoDataTablePageApiResult {
  /**  */
  result?: ScaleDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SendConfirmAccountEmailCommand {
  /**  */
  userId?: number;
}

export interface SeriesDto {
  /**  */
  name?: string;

  /**  */
  type?: string;

  /**  */
  color?: string;

  /**  */
  data?: DataPointDto[];
}

export interface SessionAttendanceDto {
  /**  */
  sessionId?: number;

  /**  */
  scheduledDate?: string;

  /**  */
  scheduledDateBeginningOfDayUnixMs?: number;

  /**  */
  participantAttended?: boolean;
}

export interface SessionAttendanceDtoListApiResult {
  /**  */
  result?: SessionAttendanceDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SessionListItemDto {
  /**  */
  id?: number;

  /**  */
  studySessionName?: string;

  /**  */
  scheduledDate?: string;

  /**  */
  participantAttended?: boolean;

  /**  */
  parentAttended?: boolean;

  /**  */
  sessionStatus?: string;

  /**  */
  interventionContactType?: string;

  /**  */
  participantPenningtonId?: string;

  /**  */
  isChild?: boolean;

  /**  */
  toolboxNeeded?: boolean;

  /**  */
  preparedMaterials?: boolean;

  /**  */
  sentMaterials?: boolean;

  /**  */
  sentToolbox?: boolean;

  /**  */
  reviewedWeight?: boolean;

  /**  */
  reviewedPreviousGoals?: boolean;

  /**  */
  reviewedMaterials?: boolean;

  /**  */
  setNewGoals?: boolean;

  /**  */
  sentGoals?: boolean;

  /**  */
  counselorId?: number;

  /**  */
  counselorName?: string;

  /**  */
  contactMethod?: string;

  /**  */
  reasonForMissing?: string;

  /**  */
  makeupSession?: boolean;

  /**  */
  sessionMaterialIds?: number[];

  /**  */
  sessionMaterialNames?: string;

  /**  */
  caloriePrescription?: number;

  /**  */
  stepsSinceLastSession?: number;

  /**  */
  activityMinutes?: number;

  /**  */
  additionalSessionInfo?: string;

  /**  */
  canMoveUpFollowingSessions?: boolean;
}

export interface SessionListItemDtoApiResult {
  /**  */
  result?: SessionListItemDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SessionListItemDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: SessionListItemDto[];
}

export interface SessionListItemDtoDataTablePageApiResult {
  /**  */
  result?: SessionListItemDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SessionMaterialBankEntryDto {
  /**  */
  id?: number;

  /**  */
  fileResourceId?: number;

  /**  */
  documentName?: string;
}

export interface SessionMaterialBankEntryListItemDto {
  /**  */
  id?: number;

  /**  */
  documentName?: string;

  /**  */
  studyNames?: string;

  /**  */
  siteNames?: string;

  /**  */
  isArchived?: boolean;

  /**  */
  status?: string;

  /**  */
  studyIds?: number[];
}

export interface SessionMaterialBankEntryListItemDtoArrayApiResult {
  /**  */
  result?: SessionMaterialBankEntryListItemDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SessionMaterialDto {
  /**  */
  id?: number;

  /**  */
  fileResource?: FileResourceUriResult;
}

export interface SessionMaterialDtoListApiResult {
  /**  */
  result?: SessionMaterialDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SessionMetricsDto {
  /**  */
  id?: number;

  /**  */
  penningtonId?: string;

  /**  */
  nickname?: string;

  /**  */
  sessionsAttendedCount?: number;

  /**  */
  parentSessionsAttendedCount?: number;

  /**  */
  sessionsMissedCount?: number;

  /**  */
  totalSessionsCount?: number;

  /**  */
  percentAttendance?: number;

  /**  */
  nextScheduledSession?: string;

  /**  */
  nextScheduledSessionName?: string;

  /**  */
  isChild?: boolean;

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;

  /**  */
  studyId?: number;

  /**  */
  studyName?: string;

  /**  */
  studyArmId?: number;
}

export interface SessionMetricsDtoListApiResult {
  /**  */
  result?: SessionMetricsDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SessionScheduleDto {
  /**  */
  id?: number;

  /**  */
  startDate?: string;

  /**  */
  frequency?: string;

  /**  */
  participantId?: number;
}

export interface SessionScheduleDtoApiResult {
  /**  */
  result?: SessionScheduleDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SettingDto {
  /**  */
  id?: number;

  /**  */
  key?: string;

  /**  */
  value?: string;

  /**  */
  isEnabled?: boolean;
}

export interface SettingDtoApiResult {
  /**  */
  result?: SettingDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SettingDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: SettingDto[];
}

export interface SettingDtoDataTablePageApiResult {
  /**  */
  result?: SettingDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SiteDto {
  /**  */
  id?: number;

  /**  */
  managerIds?: number[];

  /**  */
  name?: string;

  /**  */
  managerEmails?: string;

  /**  */
  managerNames?: string;
}

export interface SiteDtoApiResult {
  /**  */
  result?: SiteDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface SiteDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: SiteDto[];
}

export interface SiteDtoDataTablePageApiResult {
  /**  */
  result?: SiteDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StatusResult {
  /**  */
  name?: string;

  /**  */
  status?: string;
}

export interface StatusResultListApiResult {
  /**  */
  result?: StatusResult[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StickerChartActionDto {
  /**  */
  date?: Date;

  /**  */
  isCompleted?: boolean;
}

export interface StickerChartDto {
  /**  */
  goals?: StickerChartGoalDto[];

  /**  */
  participantPenningtonId?: string;

  /**  */
  isReadOnly?: boolean;
}

export interface StickerChartDtoApiResult {
  /**  */
  result?: StickerChartDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StickerChartGoalDto {
  /**  */
  goalDto?: GoalDto;

  /**  */
  stickerChartActionDates?: StickerChartActionDto[];
}

export interface StringApiResult {
  /**  */
  result?: string;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StringOptionItemDto {
  /**  */
  value?: string;

  /**  */
  label?: string;

  /**  */
  metadata?: any | null;
}

export interface StringOptionItemDtoListApiResult {
  /**  */
  result?: StringOptionItemDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StudyArmDto {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  weightLossApproach?: PercentType;

  /**  */
  percentParameter?: number;

  /**  */
  upperBoundBuffer?: number;

  /**  */
  maxUpperBound?: number;

  /**  */
  lowerBoundBuffer?: number;

  /**  */
  maxLowerBound?: number;

  /**  */
  boundModificationAmount?: number;

  /**  */
  boundModificationWeekInterval?: number;

  /**  */
  weightLossPeriod?: number;

  /**  */
  weightMaintenancePeriod?: number;

  /**  */
  studyId?: number;
}

export interface StudyArmDtoApiResult {
  /**  */
  result?: StudyArmDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StudyArmListItemDto {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  weightLossApproach?: string;

  /**  */
  percentParameter?: string;

  /**  */
  weightLossPeriod?: string;
}

export interface StudyArmListItemDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: StudyArmListItemDto[];
}

export interface StudyArmListItemDtoDataTablePageApiResult {
  /**  */
  result?: StudyArmListItemDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StudyDto {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  status?: number;

  /**  */
  numberOfParticipants?: number;

  /**  */
  groupId?: number;

  /**  */
  studyPopulations?: string[];

  /**  */
  attendance?: boolean;

  /**  */
  wellbeingAndQol?: boolean;

  /**  */
  physicalActivity?: boolean;

  /**  */
  weightTracking?: boolean;

  /**  */
  dietaryAdherence?: boolean;

  /**  */
  safetyAlerts?: boolean;

  /**  */
  selfMonitoring?: boolean;

  /**  */
  allowChildLogin?: boolean;

  /**  */
  useLegacySessionSchedule?: boolean;

  /**  */
  studySessions?: StudySessionDto[];

  /**  */
  sessionMaterialBankEntries?: SessionMaterialBankEntryDto[];
}

export interface StudyDtoApiResult {
  /**  */
  result?: StudyDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StudyListItemDto {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  status?: string;

  /**  */
  numberOfParticipants?: number;

  /**  */
  studyPopulations?: string;
}

export interface StudyListItemDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: StudyListItemDto[];
}

export interface StudyListItemDtoDataTablePageApiResult {
  /**  */
  result?: StudyListItemDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface StudySessionDto {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  sessionFrequency?: SessionFrequency;

  /**  */
  sessionMaterialBankEntries?: SessionMaterialBankEntryDto[];
}

export interface SubmitStickerChartActionCommand {
  /**  */
  date?: Date;

  /**  */
  goalId?: number;

  /**  */
  isCompleted?: boolean;

  /**  */
  participantId?: number;
}

export interface SwitchCurrentProfileCommand {
  /**  */
  participantId?: number;
}

export interface SyncWeightCommand {
  /**  */
  imei?: string;

  /**  */
  ts?: number;

  /**  */
  values?: Values;
}

export interface SyncWeightsCommand {
  /**  */
  participantId?: number;
}

export interface ToolBoxStrategyDto {
  /**  */
  id?: number;

  /**  */
  participantStrategyId?: number;

  /**  */
  toolBoxType?: ToolBoxType;

  /**  */
  strategyType?: StrategyType;

  /**  */
  strategyText?: string;

  /**  */
  isCounselorLed?: boolean;

  /**  */
  checkInDate?: string;

  /**  */
  participantStrategyStatus?: ParticipantStrategyStatus;

  /**  */
  hasActivityLink?: boolean;
}

export interface ToolBoxStrategyDtoListApiResult {
  /**  */
  result?: ToolBoxStrategyDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ToolBoxTypeDto {
  /**  */
  type?: ToolBoxType;

  /**  */
  description?: string;
}

export interface ToolBoxTypeDtoListApiResult {
  /**  */
  result?: ToolBoxTypeDto[];

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface TrophyCaseDto {
  /**  */
  trophies?: TrophyDto[];
}

export interface TrophyCaseDtoApiResult {
  /**  */
  result?: TrophyCaseDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface TrophyDto {
  /**  */
  dateEarned?: Date;

  /**  */
  isNew?: boolean;

  /**  */
  goalType?: GoalType;

  /**  */
  stickerChartActionDates?: StickerChartActionDto[];

  /**  */
  goalSchedule?: GoalScheduleDtoWithoutDate;

  /**  */
  startOfWeek?: Date;

  /**  */
  endOfWeek?: Date;

  /**  */
  penningtonId?: string;
}

export interface UnlimitedTakeDataTableRequest {
  /**  */
  take?: number;

  /**  */
  tableEcho?: number;

  /**  */
  skip?: number;

  /**  */
  allSearch?: string;

  /**  */
  columns?: DataTableColumn[];

  /**  */
  includeColumns?: boolean;
}

export interface UnlockUserCommand {
  /**  */
  userName?: string;
}

export interface UpdateActivityCommand {
  /**  */
  id?: number;

  /**  */
  participantId?: number;

  /**  */
  activityType?: ActivityType;

  /**  */
  hasRecordedSteps?: boolean;

  /**  */
  stepCount?: number;

  /**  */
  hasPerformedBreathingIncreasingActivity?: boolean;

  /**  */
  breathingIncreasingActivityDescription?: string;

  /**  */
  breathingIncreasingActivityMinutes?: number;

  /**  */
  hasInformationBeenReportedFromADevice?: boolean;

  /**  */
  hasPerformedResistanceActivity?: boolean;

  /**  */
  resistanceActivityMinutes?: number;

  /**  */
  activityDate?: Date;
}

export interface UpdateActivityTrackerCommand {
  /**  */
  id?: number;

  /**  */
  deviceName?: string;
}

export interface UpdateCommunicationPreferenceCommand {
  /**  */
  phoneNumber?: string;

  /**  */
  communicationPreference?: CommunicationPreference;
}

export interface UpdateCounselorCommand {
  /**  */
  id?: number;

  /**  */
  email?: string;

  /**  */
  name?: string;

  /**  */
  groupId?: number;

  /**  */
  hasLegacyAccess?: boolean;
}

export interface UpdateGoalCommand {
  /**  */
  id?: number;

  /**  */
  currentGoalSchedule?: GoalScheduleDtoWithoutDate;

  /**  */
  futureGoalSchedule?: GoalScheduleDto;

  /**  */
  responsibleParty?: ResponsibleParty;

  /**  */
  isInStickerChart?: boolean;

  /**  */
  isDisabled?: boolean;
}

export interface UpdateGroupCommand {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  siteId?: number;
}

export interface UpdateLegacyParticipantCommand {
  /**  */
  id?: number;

  /**  */
  penningtonId?: string;

  /**  */
  email?: string;

  /**  */
  userName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  status?: string;

  /**  */
  studyStartDate?: Date;

  /**  */
  studyEndDate?: Date;

  /**  */
  studyIntervalDays?: number;

  /**  */
  age?: number;

  /**  */
  gender?: string;

  /**  */
  height?: number;

  /**  */
  baselineWeight?: number;

  /**  */
  upperBoundBuffer?: number;

  /**  */
  lowerBoundBuffer?: number;

  /**  */
  boundModificationAmount?: number;

  /**  */
  boundModificationWeekInterval?: number;

  /**  */
  percentType?: PercentType;

  /**  */
  percentParameter?: number;

  /**  */
  counselorId?: number;

  /**  */
  scaleId?: number;
}

export interface UpdateMaterialFileNameCommand {
  /**  */
  id?: number;

  /**  */
  fileName?: string;
}

export interface UpdateParticipantCommand {
  /**  */
  id?: number;

  /**  */
  isChild?: boolean;

  /**  */
  penningtonId?: string;

  /**  */
  nickname?: string;

  /**  */
  userName?: string;

  /**  */
  email?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  communicationPreference?: CommunicationPreference;

  /**  */
  status?: string;

  /**  */
  studyStartDate?: Date;

  /**  */
  studyEndDate?: Date;

  /**  */
  firstScheduledSessionDate?: string;

  /**  */
  dateOfBirth?: string;

  /**  */
  age?: number;

  /**  */
  gender?: string;

  /**  */
  height?: number;

  /**  */
  baselineWeight?: number;

  /**  */
  counselorId?: number;

  /**  */
  scaleId?: number;

  /**  */
  activityTrackerId?: number;

  /**  */
  siteId?: number;

  /**  */
  groupId?: number;

  /**  */
  studyId?: number;

  /**  */
  studyArmId?: number;

  /**  */
  parentParticipantIds?: number[];

  /**  */
  canCheckOffStickerChartAsChild?: boolean;

  /**  */
  canViewBmiPercentile?: boolean;

  /**  */
  canViewWeightGraph?: boolean;

  /**  */
  canTrackActivity?: boolean;
}

export interface UpdateScaleCommand {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  scaleImei?: string;
}

export interface UpdateSessionBankMaterialCommand {
  /**  */
  sessionId?: number;

  /**  */
  sessionMaterialBankEntryIds?: number[];
}

export interface UpdateSessionCommand {
  /**  */
  scheduledDate?: string;

  /**  */
  sessionId?: number;

  /**  */
  moveUpFollowingSessions?: boolean;
}

export interface UpdateSessionDetailsCommand {
  /**  */
  id?: number;

  /**  */
  studySessionName?: string;

  /**  */
  scheduledDate?: string;

  /**  */
  participantAttended?: boolean;

  /**  */
  parentAttended?: boolean;

  /**  */
  sessionStatus?: string;

  /**  */
  interventionContactType?: string;

  /**  */
  participantPenningtonId?: string;

  /**  */
  isChild?: boolean;

  /**  */
  toolboxNeeded?: boolean;

  /**  */
  preparedMaterials?: boolean;

  /**  */
  sentMaterials?: boolean;

  /**  */
  sentToolbox?: boolean;

  /**  */
  reviewedWeight?: boolean;

  /**  */
  reviewedPreviousGoals?: boolean;

  /**  */
  reviewedMaterials?: boolean;

  /**  */
  setNewGoals?: boolean;

  /**  */
  sentGoals?: boolean;

  /**  */
  counselorId?: number;

  /**  */
  counselorName?: string;

  /**  */
  contactMethod?: string;

  /**  */
  reasonForMissing?: string;

  /**  */
  makeupSession?: boolean;

  /**  */
  sessionMaterialIds?: number[];

  /**  */
  sessionMaterialNames?: string;

  /**  */
  caloriePrescription?: number;

  /**  */
  stepsSinceLastSession?: number;

  /**  */
  activityMinutes?: number;

  /**  */
  additionalSessionInfo?: string;

  /**  */
  canMoveUpFollowingSessions?: boolean;
}

export interface UpdateSessionMaterialBankEntryStudiesCommand {
  /**  */
  id?: number;

  /**  */
  studyIds?: number[];
}

export interface UpdateSiteCommand {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  managerIds?: number[];
}

export interface UpdateStudyArmCommand {
  /**  */
  id?: number;

  /**  */
  name?: string;

  /**  */
  weightLossApproach?: PercentType;

  /**  */
  percentParameter?: number;

  /**  */
  upperBoundBuffer?: number;

  /**  */
  maxUpperBound?: number;

  /**  */
  lowerBoundBuffer?: number;

  /**  */
  maxLowerBound?: number;

  /**  */
  boundModificationAmount?: number;

  /**  */
  boundModificationWeekInterval?: number;

  /**  */
  weightLossPeriod?: number;

  /**  */
  weightMaintenancePeriod?: number;

  /**  */
  studyId?: number;
}

export interface UpdateUserCommand {
  /**  */
  id?: number;

  /**  */
  email?: string;

  /**  */
  name?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  username?: string;

  /**  */
  userRole?: number;

  /**  */
  status?: number;

  /**  */
  newPassword?: string;

  /**  */
  confirmNewPassword?: string;

  /**  */
  hasLegacyAccess?: boolean;
}

export interface UpdateWeightCommand {
  /**  */
  id?: number;

  /**  */
  kilograms?: number;

  /**  */
  pounds?: number;

  /**  */
  createdDate?: string;

  /**  */
  participantId?: number;

  /**  */
  height?: number;

  /**  */
  useLbs?: boolean;

  /**  */
  isExcluded?: boolean;
}

export interface UpdateWeightGraphPhaseCommand {
  /**  */
  participantId?: number;

  /**  */
  phase?: WeightGraphPhaseType;
}

export interface UserDto {
  /**  */
  id?: number;

  /**  */
  email?: string;

  /**  */
  userName?: string;

  /**  */
  name?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  status?: number;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  userRole?: number;

  /**  */
  userRoleName?: string;

  /**  */
  groupId?: number;

  /**  */
  siteGroupIds?: number[];

  /**  */
  hasLegacyAccess?: boolean;

  /**  */
  participantId?: number;

  /**  */
  participantNickName?: string;

  /**  */
  isChild?: boolean;

  /**  */
  childParticipants?: ChildParticipantDto[];

  /**  */
  currentProfileUserId?: number;

  /**  */
  currentProfileParticipantId?: number;

  /**  */
  isSwitchedToChild?: boolean;

  /**  */
  lastLoginDateUtc?: string;

  /**  */
  previousLoginDateUtc?: string;
}

export interface UserDtoApiResult {
  /**  */
  result?: UserDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface UserListItemDto {
  /**  */
  id?: number;

  /**  */
  email?: string;

  /**  */
  name?: string;

  /**  */
  emailConfirmed?: boolean;

  /**  */
  phoneNumber?: string;

  /**  */
  userRoleName?: string;

  /**  */
  status?: string;

  /**  */
  isLockedOut?: boolean;
}

export interface UserListItemDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: UserListItemDto[];
}

export interface UserListItemDtoDataTablePageApiResult {
  /**  */
  result?: UserListItemDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface ValidationError {
  /**  */
  propertyName?: string;

  /**  */
  errorMessage?: string;
}

export interface Values {
  /**  */
  weight?: number;
}

export interface WeightDto {
  /**  */
  id?: number;

  /**  */
  kilograms?: number;

  /**  */
  pounds?: number;

  /**  */
  height?: number;

  /**  */
  participant?: string;

  /**  */
  scale?: string;

  /**  */
  createdDate?: string;

  /**  */
  manuallyModified?: boolean;

  /**  */
  isExcluded?: boolean;

  /**  */
  bmip?: string;

  /**  */
  participantId?: number;

  /**  */
  useLbs?: boolean;
}

export interface WeightDtoApiResult {
  /**  */
  result?: WeightDto;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export interface WeightDtoDataTablePage {
  /**  */
  totalFilteredRecords?: number;

  /**  */
  totalRecords?: number;

  /**  */
  rows?: WeightDto[];
}

export interface WeightDtoDataTablePageApiResult {
  /**  */
  result?: WeightDtoDataTablePage;

  /**  */
  validationFailures?: ValidationError[];

  /**  */
  createdEntities?: CreatedEntity[];

  /**  */
  hasErrors?: boolean;
}

export enum ActivityType {
  'Aerobic' = 'Aerobic',
  'ResistanceMuscleStrengthening' = 'ResistanceMuscleStrengthening'
}

export enum CommunicationPreference {
  'Email' = 'Email',
  'Text' = 'Text',
  'None' = 'None'
}

export enum FeatureFlagType {
  'Toolbox' = 'Toolbox',
  'Pediatrics' = 'Pediatrics',
  'StickerChartDebug' = 'StickerChartDebug'
}

export enum GoalMetStatus {
  'NotStarted' = 'NotStarted',
  'InProgress' = 'InProgress',
  'Met' = 'Met',
  'Failed' = 'Failed'
}

export enum GoalType {
  'RedFood' = 'RedFood',
  'GreenFood' = 'GreenFood',
  'Behavior' = 'Behavior'
}

export enum MessageReplyableStatus {
  'CanReply' = 'CanReply',
  'NoReplyableMessage' = 'NoReplyableMessage',
  'ExpirationWindowClosed' = 'ExpirationWindowClosed',
  'ReplyLimitReached' = 'ReplyLimitReached'
}

export enum ParticipantStrategyAction {
  'Terminate' = 'Terminate',
  'Approve' = 'Approve',
  'Reject' = 'Reject'
}

export enum ParticipantStrategyStatus {
  'AwaitingApproval' = 'AwaitingApproval',
  'Initiated' = 'Initiated',
  'Rejected' = 'Rejected',
  'Terminated' = 'Terminated'
}

export enum PercentType {
  'PercentWeightLoss' = 'PercentWeightLoss',
  'PercentEnergyRestriction' = 'PercentEnergyRestriction'
}

export enum ResponsibleParty {
  'Child' = 'Child',
  'Parent' = 'Parent',
  'Both' = 'Both'
}

export enum SessionFrequency {
  'Daily' = 'Daily',
  'Weekly' = 'Weekly',
  'Biweekly' = 'Biweekly',
  'Monthly' = 'Monthly'
}

export enum StrategyType {
  'Text' = 'Text',
  'Numeric' = 'Numeric',
  'Checkbox' = 'Checkbox',
  'Date' = 'Date'
}

export enum ToolBoxType {
  'Attendance' = 'Attendance',
  'WellBeingAndQualityOfLife' = 'WellBeingAndQualityOfLife',
  'PhysicalActivity' = 'PhysicalActivity',
  'WeightTracking' = 'WeightTracking',
  'DietaryAdherence' = 'DietaryAdherence',
  'SelfMonitoring' = 'SelfMonitoring'
}

export enum WeightGraphIndicator {
  'Green' = 'Green',
  'Yellow' = 'Yellow',
  'Red' = 'Red',
  'Star' = 'Star',
  'Yield' = 'Yield'
}

export enum WeightGraphPhaseType {
  'ChildWeightLoss' = 'ChildWeightLoss',
  'ChildWeightMaintenance' = 'ChildWeightMaintenance'
}
